












import { Vue, Component, Prop } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import VolverButton from '@/reusable/Modal/VolverButton.vue';
import ContinuarButton from '@/reusable/Modal/ContinuarButton.vue';
import GuardarCambiosButton from '@/reusable/Modal/GuardarCambiosButton.vue';
import { FormChangeEvent, FormState } from '@/reusable/Form/formUtils';
import ContactarEjecutivoForm from '@/pantallas/SucursalVirtual/ContactarEjecutivo/ContactarEjecutivoForm.vue';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import Analitica from '@/pantallas/SucursalVirtual/analitica_uso';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    ContenidoModal,
    ContactarEjecutivoForm,
  },
})
export default class ContactarEjecutivoModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true }) usuarioSeleccionado: any;
  analytic = new Analitica(235, window.location.href);

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  async mounted() {
    let entrada = await this.analytic.entrada();
  }

  async destroyed() {
    let salida = await this.analytic.salida(this.analytic.id_analitica);
  }

  showInfo: boolean = true;

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  /* event handlers */

  handleCerrar() {
    this.$emit('cerrar');
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
}
